import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-industry-report-action-page',
  templateUrl: './industry-report-action-page.component.html',
  styleUrls: ['./industry-report-action-page.component.scss'],
})
export class IndustryReportActionPageComponent {
  company_url: any;

  constructor(private route: ActivatedRoute, private router: Router, private _location: Location) {
    this.route.params.subscribe((params) => {
      let company_name = params?.name;
      this.company_url = company_name?.toLowerCase();
      this.company_url = this.company_url?.replace('.pdf', '');
      this.company_url = this.company_url?.split(' - ')[1]?.replace(/ /g, '-');
    });
  }

  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
